import {page_header_style, Standard_Page_Layout, sub_header_style} from '../Components/Standard_Page_Layout'
import { style } from 'typestyle'
import { Splash_Main_Content } from './Splash_Main_Content'
import { useState } from 'react'
import { Client_Event_Name, Host_Event_Name } from '@quiz-buzz/common'
import { host_machine_actor } from '../App/main'

export function Splash_Page() {

	const [show_more_options, set_show_more_options] = useState(false)

	const header = (
		<>
			<div className={page_header_style}>Quiz Buzz</div>
			<div className={sub_header_style}>Run your own game show with friends!</div>
		</>
	)

	const content = (
		<Splash_Main_Content />
	)

	const controls = <>
		<div
			className={splash_button_style}
			onClick={() => host_machine_actor.send({ type: Client_Event_Name.start_host_trial_registration })}>
				Host a game
		</div>
		<div
			className={splash_button_style}
			onClick={() => host_machine_actor.send({ type: Host_Event_Name.purchase_full_game })}>
				Host a full game
		</div>
		<div
			className={splash_button_style}
			onClick={() => host_machine_actor.send({ type: Client_Event_Name.start_host_registration })}>
				Resume a game
		</div>
		<div className={splash_button_style}>
				<a href="about/">About</a>
		</div>
		{show_more_options ? <div className={more_options_style}>
			<div>Contact us at: support@quiz-buzz.com</div>
		</div> : null}

		
	</>

	return (
		<Standard_Page_Layout
			header={header}
			content={content}
			controls={controls}
			no_content_margin={true}
		/>
	)
}


const splash_button_style = style({
	display: 'flex',
	fontSize: '1.5em',
    borderRadius: '1em',
    margin: '.3rem 0 0 1.5em',
    color: 'black',
    padding: '.3em'
})

const more_options_style = style({
	display: 'flex',
	flexDirection: 'column',
	margin: '.3rem 0 0 5em',
})





